"use client";
import { useEffect, useState } from "react";
import Image from "next/legacy/image";
import {
  APIProvider,
  Map,
  useMap,
} from "@vis.gl/react-google-maps";

const API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;

// Hyderabad coordinates
const HYDERABAD_CENTER = { lat: 17.385044, lng: 78.486671 };

function TransitLayer() {
  const map = useMap();
  
  useEffect(() => {
    if (!map) return;
    
    // Add the transit layer
    const transitLayer = new google.maps.TransitLayer();
    transitLayer.setMap(map);

    // Apply custom map styling to make transit routes more prominent
    const mapStyles = [
      {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
          { "visibility": "on" },
          { "weight": 8 },
          { "color": "#1a73e8" }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
          { "visibility": "on" },
          { "weight": 3 }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          { "visibility": "on" },
          { "weight": 2 },
          { "color": "#e74c3c" }
        ]
      }
    ];
    
    map.setOptions({
      styles: mapStyles
    });
    
    return () => {
      // Clean up when component unmounts
      transitLayer.setMap(null);
    };
  }, [map]);
  
  return null;
}

export function TransitMapArea() {
  return (
    <div className="md:w-8/12 w-full md:h-full">
      <div className="flex flex-col w-full h-[75vh]">
        <TransitMapComponent />
        <div className="text-xs opacity-50 mt-2">
          Metro rail data provided by Google Maps. Metro routes and schedules may change. Please verify information before travel.
        </div>
      </div>
    </div>
  );
}

export function TransitMapComponent() {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <div className="w-full bg-cover bg-center h-full p-2 flex justify-center">
      <APIProvider apiKey={API_KEY} onLoad={() => setMapLoaded(true)}>
        {mapLoaded && (
          <Map
            defaultZoom={12}
            maxZoom={20}
            minZoom={5}
            defaultCenter={HYDERABAD_CENTER}
            gestureHandling={"cooperative"}
            disableDefaultUI={false}
            mapId={"a0623f86aad6e970"}
            style={{ border: "1px solid LightGray" }}
          >
            <TransitLayer />
          </Map>
        )}
      </APIProvider>
      {!mapLoaded && (
        <div className="hidden md:block">
          <Image
            className="display"
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${HYDERABAD_CENTER.lat},${HYDERABAD_CENTER.lng}&zoom=12&size=800x500&key=${API_KEY}`}
            alt="Map"
            width={800}
            height={500}
            priority
          />
        </div>
      )}
      {!mapLoaded && (
        <div className="block lg:hidden">
          <Image
            className="display"
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${HYDERABAD_CENTER.lat},${HYDERABAD_CENTER.lng}&zoom=12&size=400x500&key=${API_KEY}`}
            alt="Map"
            width={400}
            height={500}
            priority
          />
        </div>
      )}
    </div>
  );
} 